<template>
    <component :is="activeComponent"></component>
</template>

<script>

   import AnalysisInit from '../components/Analysis.Init';
   import AnalysisPicInit from '../components/Analysis.Pic.Init';
   import AnalysisPicCreated from '../components/Analysis.Pic.Created';
   import AnalysisPicCompilling from '../components/Analysis.Pic.Compilling';

   import {mapGetters} from 'vuex';
   import {SET_BREADCRUMB} from "@/core/store/modules/breadcrumbs";
   import {CHANGE_COMPONENT} from '../../core/store/modules/report';

   export default {
      name: "Analysis",
      data() {
         return {};
      },
      components: {
         appAnalysisInit: AnalysisInit,
         appAnalysisPicInit: AnalysisPicInit,
         appAnalysisPicCompilling: AnalysisPicCompilling,
         appAnalysisPicCreated: AnalysisPicCreated,
      },
      computed: {
         ...mapGetters([
            'activeComponent'
         ])
      },
      beforeCreate() {
         this.$store.dispatch(CHANGE_COMPONENT, 'appAnalysisInit');
         this.$store.dispatch(SET_BREADCRUMB, [{title: "Run Analysis"}]);
      }
   };
</script>